export function buildUrl(string, obj) {
  let s = string;
  for (const prop in obj) {
    s = s.replace(new RegExp('{' + prop + '}', 'g'), obj[prop]);
  }
  return s;
}

